/* MaxDx1 theme — cart drawer (Shopify AJAX API), product form, accordions, calculator */
(function () {
  const S = window.themeSettings || { freeShipThreshold: 7500, moneyFormat: '${{amount}}', cartUrl: '/cart' };

  function money(cents) {
    const amount = (cents / 100).toFixed(2);
    return S.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
  }

  /* ---------- toast ---------- */
  let toastTimer;
  function showToast(html, ms = 3800) {
    const t = document.getElementById('toast');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), ms);
  }

  /* ---------- cart drawer ---------- */
  function openCart() { document.getElementById('drawer').classList.add('show'); document.getElementById('overlay').classList.add('show'); }
  function closeCart() { document.getElementById('drawer').classList.remove('show'); document.getElementById('overlay').classList.remove('show'); }

  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
    return cart;
  }

  function renderCart(cart) {
    const box = document.getElementById('cartItems');
    if (!box) return;
    const countEl = document.getElementById('cartCount');
    if (countEl) countEl.textContent = cart.item_count;
    document.getElementById('subtotal').textContent = money(cart.total_price);

    const fill = document.getElementById('shipFill');
    const msg = document.getElementById('shipMsg');
    const threshold = parseInt(S.freeShipThreshold, 10) || 7500;
    fill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    msg.innerHTML = cart.total_price >= threshold
      ? '🎉 <b>You unlocked FREE shipping!</b>'
      : 'Add <b>' + money(threshold - cart.total_price) + '</b> more for <b>FREE shipping</b>';

    if (cart.item_count === 0) {
      box.innerHTML = '<div class="empty-cart">Your cart is empty.</div>';
      return;
    }
    box.innerHTML = cart.items.map(function (item, i) {
      const img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_128x$1$2') + '" alt="" style="width:100%;height:100%;object-fit:contain;border-radius:8px">'
        : '🧴';
      const plan = item.selling_plan_allocation ? '<span>' + item.selling_plan_allocation.selling_plan.name + '</span>' : '<span>One-time purchase</span>';
      return '<div class="ci">' +
        '<div class="thumb">' + img + '</div>' +
        '<div class="info"><b>' + item.product_title + '</b>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<span>' + item.variant_title + '</span><br>' : '') + plan +
        '<div class="qty">' +
        '<button data-line="' + (i + 1) + '" data-d="-1">−</button><span>' + item.quantity + '</span>' +
        '<button data-line="' + (i + 1) + '" data-d="1">+</button></div></div>' +
        '<div style="text-align:right"><div class="pr">' + money(item.final_line_price) + '</div>' +
        '<button class="rm" data-line="' + (i + 1) + '" data-d="remove">Remove</button></div></div>';
    }).join('');

    box.querySelectorAll('button[data-line]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        const line = parseInt(btn.dataset.line, 10);
        const item = cart.items[line - 1];
        const qty = btn.dataset.d === 'remove' ? 0 : item.quantity + parseInt(btn.dataset.d, 10);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
        });
        refreshCart();
      });
    });
  }

  async function addToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!res.ok) {
      const err = await res.json().catch(function () { return {}; });
      showToast('<b>Couldn\'t add:</b> ' + (err.description || 'please try again'));
      return null;
    }
    await refreshCart();
    openCart();
    return res;
  }

  /* ---------- wire up ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    // drawer open/close
    document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.addEventListener('click', openCart); });
    document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
    const ov = document.getElementById('overlay');
    if (ov) ov.addEventListener('click', closeCart);

    // quick add buttons
    document.querySelectorAll('[data-quick-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        addToCart([{ id: parseInt(b.dataset.quickAdd, 10), quantity: 1 }]);
        showToast('<b>Added:</b> ' + (b.dataset.title || 'Product'));
      });
    });

    // product form: intercept submit → AJAX add
    const form = document.getElementById('product-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const id = parseInt(document.getElementById('variantId').value, 10);
        const qty = parseInt(document.getElementById('quantityInput').value, 10) || 1;
        const planEl = document.getElementById('sellingPlan');
        const item = { id: id, quantity: qty };
        if (planEl && planEl.value) item.selling_plan = planEl.value;
        addToCart([item]);
        showToast('<b>Added to cart!</b>');
      });

      // variant cards
      document.querySelectorAll('.variant').forEach(function (v) {
        v.addEventListener('click', function () {
          document.querySelectorAll('.variant').forEach(function (x) { x.classList.remove('sel'); });
          v.classList.add('sel');
          document.getElementById('variantId').value = v.dataset.variantId;
          document.getElementById('pdpPrice').textContent = v.dataset.price;
          document.getElementById('pdpWas').textContent = v.dataset.compare || '';
          const btn = document.getElementById('pdpBtn');
          if (v.dataset.available === 'true') { btn.disabled = false; btn.textContent = 'Add to Cart'; }
          else { btn.disabled = true; btn.textContent = 'Sold Out'; }
        });
      });

      // selling plan options
      document.querySelectorAll('.sub-opt').forEach(function (o) {
        o.addEventListener('click', function () {
          document.querySelectorAll('.sub-opt').forEach(function (x) { x.classList.remove('sel'); });
          o.classList.add('sel');
          const planEl = document.getElementById('sellingPlan');
          if (planEl) planEl.value = o.dataset.plan || '';
        });
      });

      // quantity
      document.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          const input = document.getElementById('quantityInput');
          const span = document.getElementById('pdpQty');
          const q = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
          input.value = q; span.textContent = q;
        });
      });
    }

    // gallery thumbs
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        const main = document.getElementById('mainImage');
        if (main) main.src = t.dataset.full;
      });
    });

    // accordions
    document.querySelectorAll('[data-acc]').forEach(function (b) {
      b.addEventListener('click', function () { b.parentElement.classList.toggle('open'); });
    });

    // dosage calculator
    const tank = document.getElementById('tankSize');
    const fills = document.getElementById('fillups');
    function calcDose() {
      const out = document.getElementById('calcOut');
      if (!out) return;
      const t = Math.max(1, parseFloat(tank.value) || 18);
      const f = parseInt(fills.value, 10);
      const oz = t / 10;
      const monthly = oz * f;
      const rec = monthly * 3 <= 96 ? '3-Pack' : 'Pro Gallon';
      out.innerHTML = '<b>' + oz.toFixed(1) + ' oz per fill-up</b>' +
        '<span>≈ ' + monthly.toFixed(0) + ' oz/month · a <b style="color:var(--orange2)">' + rec + '</b> covers you for ' +
        (rec === '3-Pack' ? '3+ months' : 'a year+') + '</span>';
    }
    if (tank && fills) {
      tank.addEventListener('input', calcDose);
      fills.addEventListener('change', calcDose);
      calcDose();
    }

    refreshCart();
  });
})();
